import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { useControlled } from '../../../../internal/hooks';
export function useControlledValue(props, defaultValue) {
  var onChange = props.onChange;
  var _useControlled = useControlled({
      controlled: props.value,
      default: defaultValue
    }),
    _useControlled2 = _slicedToArray(_useControlled, 2),
    value = _useControlled2[0],
    setValue = _useControlled2[1];
  var handleChange = React.useCallback(function (value) {
    setValue(value);
    if (onChange) {
      onChange(value);
    }
  }, [onChange, setValue]);
  return {
    value: value,
    onChange: handleChange
  };
}